var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-page" }, [
    _c(
      "div",
      { staticClass: "detail-page__header" },
      [
        _vm.data.pdf
          ? _c(
              "z-link",
              {
                staticClass: "detail-page__info detail-page__info--link",
                attrs: {
                  download: _vm.data["name-pdf"],
                  href: _vm.data.pdf,
                  target: "_blank",
                  theme: "text",
                  size: "xs",
                },
              },
              [
                _c("z-icon", {
                  attrs: {
                    name: "download",
                    color: "#000000",
                    height: "20",
                    width: "20",
                    dir: "top",
                  },
                }),
                _vm._v(
                  "\n            " + _vm._s(_vm.text.download) + "\n        "
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.date
          ? _c(
              "span",
              { staticClass: "detail-page__info detail-page__info--date" },
              [
                _vm._v(
                  _vm._s(_vm._f("momentFilter")(_vm.data.date, "DD MMMM YYYY"))
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.source
          ? _c(
              "span",
              { staticClass: "detail-page__info detail-page__info--source" },
              [
                _vm._v(
                  _vm._s(_vm.text.source) +
                    "  «" +
                    _vm._s(_vm.data.source) +
                    "»"
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.componentName === "biography-detail"
      ? _c("article", { staticClass: "detail-page__body detail-bio" }, [
          _vm.data.image
            ? _c("div", { staticClass: "detail-bio__image" }, [
                _c("img", {
                  attrs: { src: _vm.data.image, alt: _vm.data.name },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "detail-bio__content" }, [
            _vm.data.position
              ? _c("p", { staticClass: "detail-bio__position" }, [
                  _vm._v(_vm._s(_vm.data.position)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.biography
              ? _c("div", {
                  staticClass: "detail-bio__text html-content",
                  domProps: { innerHTML: _vm._s(_vm.data.biography) },
                })
              : _vm._e(),
          ]),
        ])
      : _c("article", {
          staticClass: "detail-page__body html-content",
          domProps: { innerHTML: _vm._s(_vm.data.detail) },
        }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }